import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "./../../../blocks/CarouselItem";
import MiniLegend from "./../../../items/MiniLegend";
import Source from "./../../../items/Source";

import {LinePlot} from "d3plus-react";

import {numberWithCommas} from "./../../../../helpers/formatters";


class EUWideLaborDemand extends Component {

  constructor(props) {
    super(props);
    // we should move this data to a separate file outside the build
    let data = [
        {numEmp: 221030.918220479, kind: "2011 - 20", year: 2011},
        {numEmp: 221592.186766756, kind: "2011 - 20", year: 2012},
        {numEmp: 220945.398305823, kind: "2011 - 20", year: 2013},
        {numEmp: 220407.262106156, kind: "2011 - 20", year: 2014},
        {numEmp: 222599.782736798, kind: "2011 - 20", year: 2015},
        {numEmp: 228333.752071914, kind: "2011 - 20", year: 2016},
        {numEmp: 231491.842797958, kind: "2011 - 20", year: 2017},
        {numEmp: 234583.517785412, kind: "2011 - 20", year: 2018},
        {numEmp: 235110.240785266, kind: "2011 - 20", year: 2019},
        {numEmp: 235638.146464624, kind: "2011 - 20", year: 2020},
        {numEmp: 235638.146464624, kind: "2020 - 30", year: 2020},
        {numEmp: 236167.237479021, kind: "2020 - 30", year: 2021},
        {numEmp: 236697.516489952, kind: "2020 - 30", year: 2022},
        {numEmp: 237228.986164892, kind: "2020 - 30", year: 2023},
        {numEmp: 237761.6491773, kind: "2020 - 30", year: 2024},
        {numEmp: 238295.508206644, kind: "2020 - 30", year: 2025},
        {numEmp: 238830.565938403, kind: "2020 - 30", year: 2026},
        {numEmp: 239366.825064088, kind: "2020 - 30", year: 2027},
        {numEmp: 239904.288281255, kind: "2020 - 30", year: 2028},
        {numEmp: 240442.958293514, kind: "2020 - 30", year: 2029},
        {numEmp: 240982.837810548, kind: "2020 - 30", year: 2030}
    ];

    const config = {
        data,
        height: 310,
        groupBy: "kind",
        x: "year",
        discrete: "x",
        y: "numEmp",
        annotations: [
            // TODO
        ],
        xConfig: {
            gridConfig: {
              "stroke": "rgb(164, 164, 164)",
              "stroke-width": d => {
                return d.id === 2020 ? 1 : 0;
              },
              barConfig: {
                stroke: "rgb(164, 164, 164)",
                "stroke-width": 1
              }
          },

        },
        yConfig: {
          title: "Employment, thousands 2011-30",
          gridConfig: {
            "stroke": "rgb(164, 164, 164)",
            "stroke-width": 1
          },
          barConfig: {
            stroke: "rgb(164, 164, 164)",
            "stroke-width": 1
          }
        },
        legend: false,
        shapeConfig: {
          Line: {
            stroke: function(d) {
              return d.kind !== "2020 - 30" ? "rgb(0, 21, 34)" : "rgb(43, 173, 240)";
            },
            strokeWidth: 2.5
          }
        },
        tooltipConfig: {
            body: d => `<div>Employment, thousands ${d.year}: ${numberWithCommas(d.numEmp.toFixed(2))}</div>`
        },
      }
      this.state = {
        config,
        colors: [
          {color: "rgb(0, 21, 34)", label: "2011 - 20"},
          {color: "rgb(43, 173, 240)", label: "2020 - 30"}
        ]
      };
  }

  render() {
    const {colors,config} = this.state;

    return (
      <CarouselItem title="Increasing labor demand in Europe" subtitle={<>European employment enjoyed a strong recovery after 2014<sup>1</sup></>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <LinePlot config={config} />
          <Source text="1.- Linear projection of estimated employment in 2030." />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis." />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EUWideLaborDemand);
